import React, { useState } from 'react';
import { BuildingIcon, MapPinIcon, PhoneIcon, MailIcon, UserIcon, TruckIcon } from 'lucide-react';
export function CustomerInfoStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    dealerName: initialData.dealerName || '',
    dealerContact: initialData.dealerContact || '',
    dealerEmail: initialData.dealerEmail || '',
    dealerPhone: initialData.dealerPhone || '',
    billToCompany: initialData.billToCompany || '',
    billToAddress: initialData.billToAddress || '',
    billToCountry: initialData.billToCountry || '',
    shipToCompany: initialData.shipToCompany || '',
    shipToAddress: initialData.shipToAddress || '',
    shipToCountry: initialData.shipToCountry || '',
    consigneeName: initialData.consigneeName || '',
    consigneeContact: initialData.consigneeContact || '',
    consigneeEmail: initialData.consigneeEmail || '',
    consigneePhone: initialData.consigneePhone || '',
    notifyName: initialData.notifyName || '',
    notifyContact: initialData.notifyContact || '',
    notifyEmail: initialData.notifyEmail || '',
    notifyPhone: initialData.notifyPhone || '',
    ...initialData
  });
  const [sameAsBillTo, setSameAsBillTo] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSameAsBillToChange = e => {
    const checked = e.target.checked;
    setSameAsBillTo(checked);
    if (checked) {
      setFormData({
        ...formData,
        shipToCompany: formData.billToCompany,
        shipToAddress: formData.billToAddress,
        shipToCountry: formData.billToCountry
      });
    }
  };
  const handleBlur = () => {
    onUpdate(formData);
  };
  return <div className="space-y-8" data-id="element-4829" data-mp="1qftvsegvzir7">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4830" data-mp="1qgn43jvhugbg">
        Customer Information
      </div>
      {/* Dealer Information */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4831" data-mp="1ufmal8wvil50">
        <div className="flex items-center mb-4" data-id="element-4832" data-mp="2xr1oqnjutzhn">
          <BuildingIcon size={20} className="text-blue-400 mr-2" data-id="element-4833" data-mp="2st9qlbsm9h50" />
          <h3 className="text-white font-medium" data-id="element-4834" data-mp="2sszy9hk3mxw5">Dealer Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4835" data-mp="37hmmy9vm9201">
          <div data-id="element-4836" data-mp="32ijiorngmzt4">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4837" data-mp="32k4babq7s8oc">
              Dealer Name
            </label>
            <input type="text" name="dealerName" value={formData.dealerName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter dealer name" data-id="element-4838" data-mp="2eua1y453t28u" />
          </div>
          <div data-id="element-4839" data-mp="2jra629ie7uxb">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4840" data-mp="2juxyt6g0kdaz">
              Contact Person
            </label>
            <input type="text" name="dealerContact" value={formData.dealerContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4841" data-mp="3v7qmo65oohlr" />
          </div>
          <div data-id="element-4842" data-mp="3stvbu53wmuwn">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4843" data-mp="3sudepkl2o7dj">Email</label>
            <input type="email" name="dealerEmail" value={formData.dealerEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email address" data-id="element-4844" data-mp="1lz8fx6c96ww" />
          </div>
          <div data-id="element-4845" data-mp="fls6kdk72pew">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4846" data-mp="fma032fh2pj4">Phone</label>
            <input type="text" name="dealerPhone" value={formData.dealerPhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone number" data-id="element-4847" data-mp="kkld1m12dg5k" />
          </div>
        </div>
      </div>
      {/* Billing and Shipping Information */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4848" data-mp="3givvjnsdw6r9">
        {/* Bill To */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4849" data-mp="3bkawhrovbt4e">
          <div className="flex items-center mb-4" data-id="element-4850" data-mp="36lzlhdmu7ckl">
            <MapPinIcon size={20} className="text-blue-400 mr-2" data-id="element-4851" data-mp="36naohb8gkgan" />
            <h3 className="text-white font-medium" data-id="element-4852" data-mp="84djlazbo72d">Bill To</h3>
          </div>
          <div className="space-y-4" data-id="element-4853" data-mp="35ap2kgyxj8n">
            <div data-id="element-4854" data-mp="36bxsiaihtn7">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4855" data-mp="35sr5xqbaroh">
                Company Name
              </label>
              <input type="text" name="billToCompany" value={formData.billToCompany} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter company name" data-id="element-4856" data-mp="3uhc0b96orn6r" />
            </div>
            <div data-id="element-4857" data-mp="ud1168zo4h58">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4858" data-mp="udkltxgpdjmy">
                Address
              </label>
              <textarea name="billToAddress" value={formData.billToAddress} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter complete address" data-id="element-4859" data-mp="yew2hdhlmuj0"></textarea>
            </div>
            <div data-id="element-4860" data-mp="1d9kd161uwj5h">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4861" data-mp="1hcqg64to9u7q">
                Country
              </label>
              <input type="text" name="billToCountry" value={formData.billToCountry} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter country" data-id="element-4862" data-mp="1m3f97ol02z8z" />
            </div>
          </div>
        </div>
        {/* Ship To */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4863" data-mp="1bctxvvrxpa0b">
          <div className="flex items-center justify-between mb-4" data-id="element-4864" data-mp="1bahf5gecqvm7">
            <div className="flex items-center" data-id="element-4865" data-mp="16fagwo3uqj4o">
              <TruckIcon size={20} className="text-blue-400 mr-2" data-id="element-4866" data-mp="1l2df6x000vt2" />
              <h3 className="text-white font-medium" data-id="element-4867" data-mp="1l4q5pyjtoehq">Ship To</h3>
            </div>
            <div className="flex items-center" data-id="element-4868" data-mp="1gac7zphotv9w">
              <input type="checkbox" id="sameAsBillTo" checked={sameAsBillTo} onChange={handleSameAsBillToChange} className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-4869" data-mp="1u31urw51j482" />
              <label htmlFor="sameAsBillTo" className="text-sm text-blue-300" data-id="element-4870" data-mp="2417se1jtdo74">
                Same as Bill To
              </label>
            </div>
          </div>
          <div className="space-y-4" data-id="element-4871" data-mp="1z0br7vqukg5e">
            <div data-id="element-4872" data-mp="9myilubpc5yh">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4873" data-mp="9ohznn56ml1b">
                Company Name
              </label>
              <input type="text" name="shipToCompany" value={formData.shipToCompany} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter company name" data-id="element-4874" data-mp="4potkfs85wb6" />
            </div>
            <div data-id="element-4875" data-mp="2bjfrhsj4p4fi">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4876" data-mp="2bixma6ehnfvg">
                Address
              </label>
              <textarea name="shipToAddress" value={formData.shipToAddress} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter complete address" data-id="element-4877" data-mp="1xnlr5xwf7ne0"></textarea>
            </div>
            <div data-id="element-4878" data-mp="3mzxdeyp3nonw">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4879" data-mp="3n0fimktqpd7y">
                Country
              </label>
              <input type="text" name="shipToCountry" value={formData.shipToCountry} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter country" data-id="element-4880" data-mp="29s9kdnbzrh9h" />
            </div>
          </div>
        </div>
      </div>
      {/* Consignee and Notify Party */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4881" data-mp="1m38i6htr52cn">
        {/* Consignee */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4882" data-mp="1i1vb64exat45">
          <div className="flex items-center mb-4" data-id="element-4883" data-mp="1i3zmh7f5iueg">
            <UserIcon size={20} className="text-blue-400 mr-2" data-id="element-4884" data-mp="1d43hb4upwwxb" />
            <h3 className="text-white font-medium" data-id="element-4885" data-mp="3cfw7ahj3920j">Consignee</h3>
          </div>
          <div className="space-y-4" data-id="element-4886" data-mp="3cdtk059blmzi">
            <div data-id="element-4887" data-mp="37gtf3xo7iq9z">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4888" data-mp="37ie8hjysc369">Name</label>
              <input type="text" name="consigneeName" value={formData.consigneeName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter consignee name" data-id="element-4889" data-mp="3f1dpjiyrximg" />
            </div>
            <div data-id="element-4890" data-mp="3toyvrlqy3xyl">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4891" data-mp="3trkxv5v2hl9f">
                Contact Person
              </label>
              <input type="text" name="consigneeContact" value={formData.consigneeContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4892" data-mp="310t9uvo5o2x6" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4893" data-mp="l8n83f8eynuu">
              <div data-id="element-4894" data-mp="lc184gtlukz4">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4895" data-mp="pb0fs96q0vu9">
                  Email
                </label>
                <input type="email" name="consigneeEmail" value={formData.consigneeEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email" data-id="element-4896" data-mp="2iqffppg66ptq" />
              </div>
              <div data-id="element-4897" data-mp="2xe0l5q0ip14t">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4898" data-mp="2xgmsppnergn1">
                  Phone
                </label>
                <input type="text" name="consigneePhone" value={formData.consigneePhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone" data-id="element-4899" data-mp="24pwdiyydydzh" />
              </div>
            </div>
          </div>
        </div>
        {/* Notify Party */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4900" data-mp="3q37janw27opj">
          <div className="flex items-center mb-4" data-id="element-4901" data-mp="3q5229wnrt6qz">
            <PhoneIcon size={20} className="text-blue-400 mr-2" data-id="element-4902" data-mp="1eeu8t4nc8hzj" />
            <h3 className="text-white font-medium" data-id="element-4903" data-mp="19h13sexrtu0u">Notify Party</h3>
          </div>
          <div className="space-y-4" data-id="element-4904" data-mp="19j56wunuip02">
            <div data-id="element-4905" data-mp="14panztg2ee21">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4906" data-mp="14orft4g7v417">Name</label>
              <input type="text" name="notifyName" value={formData.notifyName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter notify party name" data-id="element-4907" data-mp="zrraivr6y5b5" />
            </div>
            <div data-id="element-4908" data-mp="lrq99f70kvv5">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4909" data-mp="ltauufbcp4gv">
                Contact Person
              </label>
              <input type="text" name="notifyContact" value={formData.notifyContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4910" data-mp="2g57ngblj4gdi" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4911" data-mp="e7xge0t7m0py">
              <div data-id="element-4912" data-mp="e9s0xe0kjqti">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4913" data-mp="3vofd9h0epon2">
                  Email
                </label>
                <input type="email" name="notifyEmail" value={formData.notifyEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email" data-id="element-4914" data-mp="4hciygp9v28m" />
              </div>
              <div data-id="element-4915" data-mp="i8hdj4ds94c3">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4916" data-mp="i90yyv2n6auv">
                  Phone
                </label>
                <input type="text" name="notifyPhone" value={formData.notifyPhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone" data-id="element-4917" data-mp="na6qwqoh9u3c" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}